// Danish

const lang = {
  gateMediaPreviewHeader: 'Du vil måske også kunne lide',
  loadmore: 'Vis mere',
  nextMedia: 'Næste medie',
  previousMedia: 'Tidligere medie',
  closePost: 'Luk indlæg',
  nextPost: 'Næste indlæg',
  previousPost: 'Forrige indlæg',
  outOfStock: 'Udsolgt',
  numberOfReviews(n) {
    return n === 1 ? 'anmeldelse' : 'anmeldelser'
  },
  reportFormField: 'Indtast en besked',
  reportPost: 'Rapportér indlæg',
  reportFormTitle: 'Ønsker du at rapportere dette billede?',
  reportFormDetails:
    'Hvis du mener at billedet er upassende, illegalt, eller krænker andres rettigheder, kan du rapportere indholdet. Hvis du rapporterer dette billede / denne tekst, bliver indholdsmoderatoren underrettet og de relevante foranstaltninger vil blive truffet.',
  reportFormMessagePlaceholder: 'Angiv din årsag til din rapport',
  reportFormMessageLabel: 'Besked',
  reportFormEmailLabel: 'Din e-mail',
  reportFormSubmitButtonText: 'Send rapport',
  reportFormCancelButtonText: 'Annuller',
  reportFormSentTitle: 'Tak for din rapport!',
  reportFormSentCloseButtonText: 'Luk',
  cardAndTileAriaLabel: 'Liste over opslag fra konti på forskellige sociale medier',
  carouselAriaLabel: 'Karrusel med opslag fra konti på forskellige sociale medier',
  singleAriaLabel: 'Nedenfor er et opslag fra en social mediekonto',
  poweredBy: 'Drevet af Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` offentliggjort på ${date}` : ''
    const createdByString = userName ? ` af ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Upload dine medier',
  openTheGate: 'Åbn dialogen',
  gridRoleDescription: 'gitter',
  carouselRoleDescription: 'karrusel',
  tiktokVideoAriaLabel: 'Indlejret TikTok-video. Tryk på afspil for at se indholdet.',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `Medie-miniature ${postIndex + 1} af ${maxPosts}, åbner dialog med indhold fra sociale medier og fremhævede produkter.`,
  carouselControlButtonsAriaLabel: 'Knapper til styring af karrusel',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) =>
    `Medie ${mediaIndex + 1} af ${maxMedia}`,
  showMoreCaption: 'Vis mere billedtekst',
  showLessCaption: 'Vis mindre billedtekst',
  originalPrice: (price) => `Originalpris: ${price}`,
  salesPrice: (price) => `Tilbudspris: ${price}`,
  postPublishedBy: 'Opslag offentliggjort af',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'Video' : 'Billede'
    const user = username ? `${username}` : 'ukendt bruger'
    const publishDate = date ? `den ${date}` : ''
    return `${mediaType} lagt op af ${user} ${publishDate}. Det kan være ${altText}`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `Opslag ${postIndex + 1} af ${maxPosts}.`,
}

export default lang
